(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("shoppingCartService", ["$localStorage", "_", "shoppingCartResource", "authService", "messageService", "$rootScope", shoppingCartService]);
    function shoppingCartService($localStorage, _, shoppingCartResource, authService, messageService, $rootScope) {
        var shoppingCartServiceFactory = {};
        var addToCart = function (productId, quantity, callBack, extraInformation) {
            if (!$localStorage.storefrontCart3)
                $localStorage.storefrontCart3 = { cartItems: [] };
            var inCart = _.some($localStorage.storefrontCart3.cartItems, { productId: productId });
            if (!inCart) {
                var productToAdd = { productId: productId, quantity: quantity, added: new Date(), extraInformation: extraInformation };
                if (authService.authentication.isAuth) {
                    shoppingCartResource.addToMyShoppingCart(productToAdd, function () {
                        $localStorage.storefrontCart3.cartItems.push(productToAdd);
                        $rootScope.$broadcast("updateShoppingCartCount", getCartCount());
                        if (callBack)
                            callBack();
                    }, function (error) {
                        messageService.error(error);
                    });
                }
                else {
                    $localStorage.storefrontCart3.cartItems.push(productToAdd);
                    $rootScope.$broadcast("updateShoppingCartCount", getCartCount());
                    if (callBack)
                        callBack();
                }
                return true;
            }
            else {
                return false;
            }
        };
        var removeFromCart = function (productId, callBack) {
            if (authService.authentication.isAuth) {
                var cartItem = { productId: productId };
                shoppingCartResource.removeFromMyShoppingCart(cartItem, function () {
                    $localStorage.storefrontCart3.cartItems = _.without($localStorage.storefrontCart3.cartItems, _.find($localStorage.storefrontCart3.cartItems, { productId: productId }));
                    $rootScope.$broadcast("updateShoppingCartCount", getCartCount());
                    $rootScope.$broadcast("removedFromCart", productId);
                    if (callBack)
                        callBack();
                }, function (error) {
                    messageService.error(error);
                });
            }
            else {
                $localStorage.storefrontCart3.cartItems = _.without($localStorage.storefrontCart3.cartItems, _.find($localStorage.storefrontCart3.cartItems, { productId: productId }));
                $rootScope.$broadcast("updateShoppingCartCount", getCartCount());
                $rootScope.$broadcast("removedFromCart", productId);
                if (callBack)
                    callBack();
            }
        };
        var isInCart = function (productId) {
            if (!$localStorage.storefrontCart3)
                return false;
            return _.some($localStorage.storefrontCart3.cartItems, { productId: productId });
        };
        var getCartCount = function () {
            if ($localStorage.storefrontCart3 && $localStorage.storefrontCart3.cartItems)
                return $localStorage.storefrontCart3.cartItems.length;
            return 0;
        };
        //Load the cart info from db to local storage
        var synchronizeShoppingCart = function (callback) {
            if (authService.authentication.isAuth) {
                var anonymousCart = { cartItems: [] };
                if ($localStorage.storefrontCart3 && $localStorage.storefrontCart3.cartItems)
                    anonymousCart = $localStorage.storefrontCart3;
                //TODO: USE angularJsShoppingCart instead of storefrontCart3
                shoppingCartResource.synchronize(anonymousCart, function (result) {
                    var _a;
                    $localStorage.storefrontCart3 = {
                        cartItems: _.map(result.cartItems, function (item) {
                            var _a, _b;
                            return {
                                productId: item.productId,
                                quantity: item.quantity,
                                added: item.added,
                                extraInformation: item.extraInformation,
                                discountCode: (_b = (_a = item.discountInfo) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : ""
                            };
                        })
                    };
                    if ((_a = result.discountInfo) === null || _a === void 0 ? void 0 : _a.code)
                        $localStorage.storefrontCart3.discountCode = result.discountInfo.code;
                    $rootScope.$broadcast("updateShoppingCartCount", getCartCount());
                    if (result.error)
                        messageService.warning(result.error);
                    if (callback)
                        callback(result.hasAssignedPath && result.purchaseTypeId !== 2);
                }, function (error) {
                    messageService.error(error);
                });
            }
        };
        var clear = function (success) {
            if (authService.authentication.isAuth) {
                shoppingCartResource.clear(function () {
                    delete $localStorage.storefrontCart3;
                    $rootScope.$broadcast("updateShoppingCartCount", getCartCount());
                    if (success)
                        success();
                }, function (error) {
                    messageService.error(error);
                });
            }
        };
        var clearServerCart = function (success) {
            if (authService.authentication.isAuth) {
                shoppingCartResource.clear(function () {
                    if (success)
                        success();
                }, function (error) {
                    messageService.error(error);
                });
            }
        };
        var addSession = function (productId, itemCode, sessionId) {
            //Check if item is already in cart
            if (!isInCart(productId)) {
                var extraInformation = {
                    sessions: {}
                };
                extraInformation.sessions[itemCode] = sessionId;
                addToCart(productId, 1, function () {
                    $rootScope.$broadcast("cartChanged", productId);
                }, extraInformation);
            }
            else {
                //Add Session Information
                var cart = _.find($localStorage.storefrontCart3.cartItems, { productId: productId });
                if (!cart.extraInformation)
                    cart.extraInformation = {
                        sessions: {}
                    };
                if (!cart.extraInformation.sessions)
                    cart.extraInformation.sessions = {};
                cart.extraInformation.sessions[itemCode] = sessionId;
                synchronizeShoppingCart();
            }
        };
        var getSessions = function (productId) {
            if (!$localStorage.storefrontCart3)
                return null;
            var cart = _.find($localStorage.storefrontCart3.cartItems, { productId: productId });
            if (!cart || !cart.extraInformation)
                return null;
            return cart.extraInformation.sessions;
        };
        var removeSession = function (productId, itemCode) {
            var cart = _.find($localStorage.storefrontCart3.cartItems, { productId: productId });
            if (!cart.extraInformation)
                return;
            if (!cart.extraInformation.sessions)
                return;
            delete cart.extraInformation.sessions[itemCode];
            synchronizeShoppingCart();
        };
        shoppingCartServiceFactory.addToCart = addToCart;
        shoppingCartServiceFactory.removeFromCart = removeFromCart;
        shoppingCartServiceFactory.isInCart = isInCart;
        shoppingCartServiceFactory.getCartCount = getCartCount;
        shoppingCartServiceFactory.synchronizeShoppingCart = synchronizeShoppingCart;
        shoppingCartServiceFactory.clear = clear;
        shoppingCartServiceFactory.clearServerCart = clearServerCart;
        shoppingCartServiceFactory.addSession = addSession;
        shoppingCartServiceFactory.getSessions = getSessions;
        shoppingCartServiceFactory.removeSession = removeSession;
        return shoppingCartServiceFactory;
    }
}());
